const projectReducer = (state = {}, action) => {
    switch (action.type) {      
      case "PROJECT_STATUS":
        return Object.assign({}, state, {
          projectStatus : action.data,
        });    
        case "PROJECT_LIST":
          return Object.assign({}, state, {
            projectList : action.data,
          });
          case "PROJECT_NAMES":
          return Object.assign({}, state, {
            projectNames : action.data,
          });    
      default:
        return state;
    }
  };
  
  export default projectReducer;
  